import { RootState } from "@/models/RootState.type";
import { AppDispatch } from "@/models/AppDispatch.type";
import { createListenerMiddleware } from "@reduxjs/toolkit";
import { fetchStudentMastery, updateSkillMasteryQueue } from "../slices";
import moment from 'moment';

export const addUpdateMasteryQueueListenerMiddleware = (
  listenerMiddleware: ReturnType<typeof createListenerMiddleware>
) => {
  listenerMiddleware.startListening.withTypes<RootState, AppDispatch>()({
    actionCreator: updateSkillMasteryQueue,
    effect: async (action: any, listenerApi: any) => {
      try {
        const { weeklyPlan } = listenerApi.getState() as RootState;
        if (
          weeklyPlan.data?.masteryFetchQueue &&
          weeklyPlan.data.masteryFetchQueue.length
        ) {
          const masteryFetchQueue = [...weeklyPlan.data.masteryFetchQueue];
          let masteryPop = masteryFetchQueue.pop();
          if (masteryPop) {
            const dateFrom = moment(masteryPop.dateFrom, 'YYYY-MM-DD');
            const today = moment();
            const earlierDate = dateFrom.isBefore(today) ? dateFrom : today;
            const masteryInput = {
              ...masteryPop,
              dateFrom: earlierDate.format('YYYY-MM-DD')
            };
            if (masteryInput) {
              listenerApi.dispatch(fetchStudentMastery({ input: masteryInput }));
              listenerApi.dispatch(updateSkillMasteryQueue(masteryFetchQueue));
            }
          }
        }
      } catch (error) {
        console.error("Error fetching skill mastery in queue", error);
        // listenerApi.dispatch(setLoading(AsyncLoadingState.ERROR));
      }
    },
  });
};
